import styled from "styled-components";
import media from "styled-media-query";

import { Text, ColorV2 } from "@adoptaunabuelo/react-components";

const Container = styled.div`
	display: flex;
	gap: 16px;
	align-items: stretch;
	min-width: 0;
	${media.lessThan("medium")`
        flex-direction: column;
        gap: 24px;
    `};
`;
const TextSide = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: 24px;
	min-width: 0;
	order: 1;
	${media.lessThan("medium")`
        order: 2;
        gap: 16px;
    `};
`;
const TextBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;
const Title = styled(Text)`
	font-size: 24px !important;
	line-height: 32px !important;
	font-weight: 600 !important;
	color: ${ColorV2.text.neutralHard};
	margin: 0;
`;
const Description = styled(Text)`
	font-size: 14px !important;
	line-height: 22px !important;
	font-weight: 400 !important;
	color: ${ColorV2.text.neutralHard};
	margin: 0;
`;
const Quote = styled(Text)`
	font-size: 17px !important;
	line-height: 24px !important;
	font-weight: 500 !important;
	color: ${ColorV2.text.primary};
	margin: 0;
`;
const ImageSide = styled.div`
	display: flex;
	flex: 1;
	min-width: 0;
	order: 2;
	${media.lessThan("medium")`
        order: 1;
    `};
`;
const Image = styled.img`
	width: 100%;
	height: 300px;
	border-radius: 16px;
	object-fit: cover;
	${media.lessThan("medium")`
        aspect-ratio: 1 / 1;
        height: auto;
    `};
`;

const ActivityCell = (props: ActivityCellProps) => {
	return (
		<Container>
			<ImageSide>
				<Image src={props.img} alt={props.title} />
			</ImageSide>
			<TextSide>
				<TextBlock>
					<Title type="h4">{props.title}</Title>
					<Description type="p">{props.description}</Description>
				</TextBlock>
				<Quote type="p">"{props.quote}"</Quote>
			</TextSide>
		</Container>
	);
};
export default ActivityCell;
export interface ActivityCellProps {
	title: string;
	description: string;
	quote: string;
	img: string;
	video: string;
}
